import axios from 'axios'
// import {
// 		closeWebsocket
// 	} from '@/utils/websocket.js'
import {
	MessageBox, Message
} from 'element-ui'
// import router from '../router/index.js'
import { closeWebsocket } from './websocket.js'
import store from '../store/store.js'
import config from './electronConfig.js'
var BASE_URL = process.env.VUE_APP_BASEURL //项目管理系统
axios.get('/sever.json').then(response => {
	BASE_URL = response.data.base_url
})
// var BASE_BOT_URL = process.env.VUE_APP_BOTURL //机器人接口前缀
var BASE_IMAGE_URL = process.env.VUE_APP_IMGURL
var SERVICE_URL = ''
var WEB_VERSION = process.env.VUE_APP_VERSION


// electron dev
// const electronCache = "./static/loginInfo.json"
// electron pro
// const electronCache = "./resources/static/loginInfo.json"
// const electronCache = "D:/ZBT_loginInfo.json"
// const electronCache = "C:/Users/86157/loginInfo.json"

// var heartTimer = ''
// var wsReconCount = 0

// export var WSSTATE_NORMAL = "0";//ws正常退出
// export var WSSTATE_CONN_SUCC = "1";//连接成功
// export var WSSTATE_RECONNECTION = "2";//重连
// export var WSSTATE_KICKOUT = "3";//踢出

localStorage.setItem('version', WEB_VERSION)
localStorage.setItem('imgUrl', BASE_IMAGE_URL)

//服务端提供的信息码
const successCode = '10000' //业务处理成功
const noTokenCode = '401' //token已过期

var audio = null
var newAudio = null
var getAudio = null //获取手机号或者微信

export default {
	// // 防抖
	// debounce(fn) {
	// 	let flag = true
	// 	return function () {
	// 		if (flag) {
	// 			fn.apply(this)
	// 		}
	// 	}
	// },

	// electronCache,
	//2. 缓动的机制 实现返回顶部
	animation(obj, target) {
		clearInterval(obj.timer)
		obj.timer = setInterval(function () {
			var temp = (target - obj.scrollTop) / 10
			console.log(temp);
			temp = temp <= 0 ? Math.floor(temp) : Math.ceil(temp)
			if (target >= obj.scrollTop) {
				clearInterval(obj.timer)
			}
			obj.scrollTo(0, obj.scrollTop + temp)
		}, 20)
		obj.addEventListener("wheel", function () {
			clearInterval(obj.timer)
		})
	},
	//获取当前时间并格式化 yyyy-MM-dd HH:mm:ss 
	getFormatDate(type) {
		// console.log('utiljs getFormatDate')
		var date = new Date();
		var month = date.getMonth() + 1;
		if (month >= 1 && month <= 9) {
			month = "0" + month;
		}

		var strDate = date.getDate();
		if (strDate >= 0 && strDate <= 9) {
			strDate = "0" + strDate;
		}

		var strHour = date.getHours();
		if (strHour >= 0 && strHour <= 9) {
			strHour = "0" + strHour;
		}

		var strMinute = date.getMinutes();
		if (strMinute >= 0 && strMinute <= 9) {
			strMinute = "0" + strMinute;
		}

		var strSecond = date.getSeconds();
		if (strSecond >= 0 && strSecond <= 9) {
			strSecond = "0" + strSecond;
		}

		var currentDate = ''
		if (type === 0) {
			//格式一：yyyy-MM-dd HH:mm:ss
			currentDate = date.getFullYear() + "-" + month + "-" + strDate +
				" " + strHour + ":" + strMinute + ":" + strSecond;
		} else if (type === 1) {
			//格式二：MM-dd HH:mm:ss
			currentDate = month + "-" + strDate +
				" " + strHour + ":" + strMinute + ":" + strSecond;
		} else if (type === 2) {
			//格式三：HH:mm
			currentDate = strHour + ":" + strMinute
		} else if (type === 3) {
			currentDate = date.getFullYear() + "-" + month + "-" + strDate
		}

		return currentDate;
	},

	//将时间戳转换成 yyyy-MM-dd HH:mm:ss
	//inputTime 参数是毫秒级时间戳 13位
	timeStampToDate(inputTime, type) {
		if (inputTime.length === 0) {
			return
		}

		var date = new Date(inputTime);
		console.log("util.js timeStampToDate:", new Date(inputTime), inputTime)
		var y = date.getFullYear();
		var m = date.getMonth() + 1;
		m = m < 10 ? ('0' + m) : m;
		var d = date.getDate();
		d = d < 10 ? ('0' + d) : d;
		var h = date.getHours();
		h = h < 10 ? ('0' + h) : h;
		var minute = date.getMinutes();
		var second = date.getSeconds();
		minute = minute < 10 ? ('0' + minute) : minute;
		second = second < 10 ? ('0' + second) : second;

		var currentDate = ''
		if (type === 0) {
			//格式一：yyyy-MM-dd HH:mm:ss
			currentDate = y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
		} else if (type === 1) {
			//格式二：MM-dd HH:mm:ss
			currentDate = m + '-' + d + ' ' + h + ':' + minute + ':' + second;
		} else if (type === 2) {
			//格式三：HH:mm
			currentDate = h + ':' + minute
		} else if (type === 3) {
			currentDate = y + "-" + m + '-' + d
		} else if (type === 4) {
			currentDate = h + ':' + minute + ":" + second
		}

		return currentDate;
	},
	// 给日期时间选择器赋值
	handleGetTime: (start, end, dateValue) => {
		if (dateValue === null) {
			dateValue = [];
		}
		dateValue.splice(
			0,
			2,
			new Date(start).getTime(),
			new Date(end).getTime()
		);
	},
	nowTimeStamp() {
		var timestamp = Date.parse(new Date())

		return timestamp / 1000
	},

	changeGender(igender) {
		if (igender === '1') {
			return '男'
		} else if (igender === '0') {
			return '女'
		}

		return ''
	},

	changeAge(age) {
		if (age === null) {
			return ''
		} else if (age === '') {
			return ''
		}

		return age + '岁'
	},

	nullToString(str) {
		if (str === null) {

			return ''
		}
		return str
	},

	// 访客 IP：优先 ip，其次 ipv4，再次 ipv6
	getVisitorIp(info) {
		if (!info) {
			return ''
		}
		const pick = (v) => {
			if (v === null || v === undefined) {
				return ''
			}
			const s = String(v).trim()
			return s
		}
		return pick(info.ip) || pick(info.ipv4) || pick(info.ipv6) || ''
	},

	setLocalNewUrl(url) {
		localStorage.setItem('newaudiourl', url)
	},

	setLocalFlickerUrl(url) {
		localStorage.setItem('flickeraudiourl', url)
	},

	setLocalZhuanqianUrl(url) {
		localStorage.setItem('changeurl', url)
	},

	setLocalProgressUrl(url) {
		localStorage.setItem('progressurl', url)
	},


	getLocalNewUrl() {
		localStorage.getItem('newaudiourl')
	},

	getLocalFlickerUrl() {
		localStorage.getItem('flickeraudiourl')
	},

	getLocalZhuanqianUrl() {
		return localStorage.getItem('changeurl')
	},

	getLocalProgressUrl() {
		return localStorage.getItem('progressurl')
	},

	setLocalKeyUrl(url) {
		localStorage.setItem('keyAudioUrl', url)
	},
	getLocalKeyUrl() {
		localStorage.getItem('keyAudioUrl')
	},

	getLocalImgUrl() {
		// return localStorage.getItem('imgUrl')
		const site = JSON.parse(localStorage.getItem("siteObj"))
		if (site !== null) {
			return site.resource_url
		}

		return ''
	},

	getLocalFlickerList() {

		var list = null
		var jsonList = localStorage.getItem('flickerList')
		if (jsonList === null) {
			list = []

			return list
		}

		list = JSON.parse(jsonList)

		return list
	},

	addToLocalFlickerList(talkObj) {

		var list = []
		var jsonList = localStorage.getItem('flickerList')
		if (jsonList !== null) {
			list = JSON.parse(jsonList)
		}

		list.push(talkObj)

		localStorage.setItem('flickerList', JSON.stringify(list))
	},

	removeLocalFlicker(itemObj) {
		var list = []
		var jsonList = localStorage.getItem('flickerList')
		if (jsonList === null) {
			return
		}

		list = JSON.parse(jsonList)
		for (var i = 0; i < list.length; i++) {
			const obj = list[i]
			if (obj.cid === itemObj.cid && obj.sid === itemObj.sid) {
				list.splice(i, 1)
			}
		}
		localStorage.setItem('flickerList', JSON.stringify(list))
	},

	// playFlickerAudio() {
	// 	console.log('util playFlickerAudio')

	// 	const audioUrl = localStorage.getItem('flickeraudiourl')
	// 	if (audioUrl.length === 0) {
	// 		return
	// 	}

	// 	if (audio === null) {
	// 		audio = new Audio()
	// 		audio.src = localStorage.getItem('flickeraudiourl')//'http://medibot.cc/images/upload/music1.mp3' //store.state.flickerAudioUrl
	// 		audio.loop = true

	// 		var playPromise = audio.play()
	// 		if (playPromise) {
	// 			playPromise.then(() => {
	// 				// 音频加载成功 
	// 				// 音频的播放需要耗时
	// 				setTimeout(() => {
	// 					// 后续操作 
	// 					console.log("util playFlickerAudio done.")
	// 				}, audio.duration * 1000); // audio.duration 为音频的时长单位为秒
	// 				}).catch((e) => {
	// 					// 音频加载失败
	// 					console.log("util playFlickerAudio err = ", e)
	// 					Message.error('提示音报错了: ', e)
	// 				})
	// 		}
	// 	}
	// },



	replaceBdToEmoji(bdContent) {
		// console.log('homeChat replaceBdToEmoji bdContent = ', bdContent)

		var toRe1 = "[微笑]"
		bdContent = bdContent.replace(toRe1, '/::)')

		var toRe2 = '[调皮]'
		bdContent = bdContent.replace(toRe2, '/::P')

		var toRe3 = '[色]'
		bdContent = bdContent.replace(toRe3, '/::B')

		var toRe4 = '[睡]'
		bdContent = bdContent.replace(toRe4, '/::Z')

		var toRe5 = '[疑问]'
		bdContent = bdContent.replace(toRe5, '/:?')

		var toRe6 = '[流泪]'
		bdContent = bdContent.replace(toRe6, '/::<')

		var toRe7 = '[汗]'
		bdContent = bdContent.replace(toRe7, '/::L')

		var toRe8 = '[晕]'
		bdContent = bdContent.replace(toRe8, '/:,@@')

		var toRe9 = '[撇嘴]'
		bdContent = bdContent.replace(toRe9, '/::~')

		var toRe10 = '[惊恐]'
		bdContent = bdContent.replace(toRe10, '/::!')

		var toRe11 = '[尴尬]'
		bdContent = bdContent.replace(toRe11, '/::-|')

		var toRe12 = '[害羞]'
		bdContent = bdContent.replace(toRe12, '/::$')

		var toRe13 = '[委屈]'
		bdContent = bdContent.replace(toRe13, '/:P-(')

		var toRe14 = '[大笑]'
		bdContent = bdContent.replace(toRe14, '/::D')

		var toRe15 = '[大哭]'
		bdContent = bdContent.replace(toRe15, "/::'(")

		var toRe16 = '[可爱]'
		bdContent = bdContent.replace(toRe16, '/:,@-D')

		var toRe17 = '[再见]'
		bdContent = bdContent.replace(toRe17, '/:bye')

		var toRe18 = '[偷笑]'
		bdContent = bdContent.replace(toRe18, '/:,@P')

		var toRe19 = '[乖]'
		bdContent = bdContent.replace(toRe19, '/:X-)')

		var toRe20 = '[难过]'
		bdContent = bdContent.replace(toRe20, '/::(')

		return bdContent
	},

	playFlickerAudio() {
		const audioUrl = localStorage.getItem('flickeraudiourl')
		if (audioUrl === null) {
			return
		}
		audio = document.getElementById('audio')//获取audio
		audio.loop = false
		if (audio !== null && !audio.ended) {
			setTimeout(() => {
				audio.pause()
				console.log("util flicker audio pause.")
				audio.currentTime = 0
			}, 200)
			setTimeout(() => {
				// 后续操作
				let playPromise = audio.play()
				if (playPromise) {

					playPromise.then(() => {
						console.log("util flicker audio playing1.")

					}).catch((e) => {
						// 音频加载失败
						console.log("util flicker audio err = ", e)
						// Message.error('恭喜音频报错了: ', e)
					})
				}
			}, 300);
		} else {
			setTimeout(() => {
				// 后续操作
				let playPromise = audio.play()
				if (playPromise) {

					playPromise.then(() => {
						console.log("util flicker audio playing2.")

					}).catch((e) => {
						// 音频加载失败
						console.log("util flicker audio err = ", e)
						// Message.error('恭喜音频报错了: ', e)
					})
				}
			}, 300);
		}


	},

	pauseFlickerAudio() {
		console.log("暂停放音")
		// audio = document.getElementById('audio')//获取audio
		// audio.loop = false
		// if (audio !== null) {
		// 	audio.pause()
		// }
	},

	playGetAudio() {
		if (getAudio === null) {
			getAudio = new Audio()

			const site = JSON.parse(localStorage.getItem("siteObj"))
			if (site === null) {
				return
			}
			if(store.state.zhuanQianAudioUrl.length == 0){
				return;
			}

			console.log("playGetAudio=" + site.resource_url + '/audio/default/zhuanqian.mp3');
			getAudio.src = store.state.zhuanQianAudioUrl;
			//getAudio.src = site.resource_url + '/audio/default/zhuanqian.mp3' //store.state.flickerAudioUrl
			getAudio.loop = false
			var playPromise = getAudio.play()
			if (playPromise) {

				playPromise.then(() => {
					// 音频加载成功
					// 音频的播放需要耗时
					setTimeout(() => {
						// 后续操作
						getAudio = null
						console.log("util playGetAudio done.")
					}, getAudio.duration * 1000); // audio.duration 为音频的时长单位为秒
				}).catch((e) => {
					// 音频加载失败
					console.log("util playGetAudio err = ", e)
					// Message.error('恭喜音频报错了: ', e)
				})
			}
		}
	},


	playErrTipAudio() {

		if (getAudio === null) {
			getAudio = new Audio()
			const site = JSON.parse(localStorage.getItem("siteObj"))
			if (site === null) {
				return
			}

			getAudio.src = site.resource_url + '/audio/default/network_err.mp3' //'http://medibot.online/images/upload/crow.mp3' //store.state.flickerAudioUrl
			getAudio.loop = false

			var playPromise = getAudio.play()

			if (playPromise) {
				playPromise.then(() => {
					// 音频加载成功
					// 音频的播放需要耗时
					setTimeout(() => {
						// 后续操作
						console.log("util playGetAudio done.")
						getAudio = null
					}, getAudio.duration * 1000); // audio.duration 为音频的时长单位为秒
				}).catch((e) => {
					// 音频加载失败
					console.log("util playGetAudio err = ", e)
					// Message.error('恭喜音频报错了: ', e)
				})
			}
		}
	},

	playNewAudio() {

		const audioUrl = localStorage.getItem('newaudiourl')

		if (audioUrl.length === 0) {
			return
		}

		if (newAudio === null) {
			newAudio = new Audio()
			newAudio.src = localStorage.getItem('newaudiourl') //'http://medibot.cc/images/upload/crow.mp3' //'http://medibot.cc/images/upload/music2.mp3'
			newAudio.loop = true
			newAudio.play()
		}
	},

	playProgressAudio() {

		const audioUrl = localStorage.getItem('progressurl')

		if (audioUrl.length === 0) {
			return
		}

		if (newAudio === null) {
			newAudio = new Audio()
			newAudio.src = localStorage.getItem('progressurl') //'http://medibot.cc/images/upload/crow.mp3' //'http://medibot.cc/images/upload/music2.mp3'
			newAudio.loop = false
			let playCount = 0
			newAudio.addEventListener('ended', function() {
				playCount++
				if (playCount < 3) {
					newAudio.play()
				} else {
					newAudio = null
				}
			})
			newAudio.play()
		}
	},

	pauseNewAudio() {
		if (newAudio !== null) {
			newAudio.pause()
			newAudio = null
		}
	},

	//将当前时间转换成时间戳
	dateToTimestamp(date) {
		return parseInt(date.getTime() / 1000) //现在：new Date()
	},

	setLocalItem(userid, key, options) {

		let userInfo = localStorage.getItem(userid)
		if (userInfo === null) {

			var map = {}
			map["" + key + ""] = options

			console.log('util setLocalItem map = ', map)

			localStorage.setItem(userid, map)
		}
	},

	getLocalItem(userid, key) {
		let userInfo = localStorage.getItem(userid)
		if (userInfo === null) {
			return null
		}

		const localValue = JSON.parse(localStorage.getItem(key))

		return localValue
	},

	setLoginTip(isLogin) {
		localStorage.setItem('loginSuccess', isLogin)
	},

	getLoginTip() {
		//1-登录成功 0-未登录或者登录失败
		return localStorage.getItem('loginSuccess')
	},

	setLocalToken(token) {
		localStorage.setItem('token', token)
	},

	getLocalToken() {
		return localStorage.getItem('token')
	},

	getLocalId() {
		var account = JSON.parse(localStorage.getItem("account"))
		if (account === null) {
			localStorage.setItem('wsState', '5')
			localStorage.setItem('loginSuccess', '0')
			closeWebsocket()
			// setTimeout(() => {

			// 	router.push('/')
			// 	localStorage.setItem("token",null)
			// }, 300)

			return
		}

		return account.id
	},

	getLocalAccount() {
		var account = JSON.parse(localStorage.getItem("account"))
		if (account === null) {
			localStorage.setItem('wsState', '5')
			localStorage.setItem('loginSuccess', '0')
			localStorage.setItem('timeLength', '0秒')
			closeWebsocket()
			// setTimeout(() => {
			// 	router.push('/')
			// }, 300)

			return {}
		}

		return account
	},

	setLocalAccount(jsonStr) {
		localStorage.setItem('account', jsonStr)
	},

	getLocalSite() {
		return JSON.parse(localStorage.getItem("siteObj"))
	},

	setLocalFree(isFree) {
		localStorage.setItem('loginFree', isFree) //免登录标记
	},

	getLocalFree() {
		//1-免登录 
		return localStorage.getItem('loginFree')
	},

	setLocalNetTip(istate) {
		//istate：1-网络正常 2-网络报错 3-用户被踢出
		localStorage.setItem('netState', istate)
	},

	getLocalNetTip() {
		return localStorage.getItem('netState')
	},

	setWsState(istate) {
		//0-正常关闭 1-ws链接成功 2-尝试重连 3-被踢出 4-401token过期 5-用户清缓存之后再使用跳到登录
		localStorage.setItem('wsState', istate)
	},

	getLocalWsState() {
		return localStorage.getItem('wsState')
	},

	setLocalPermit(jsonStr) {
		localStorage.setItem('permission', jsonStr)
	},

	getLocalPermintObj() {
		return JSON.parse(localStorage.getItem("permission"))
	},

	getLocalPermit(keyName) {
		const permitObj = JSON.parse(localStorage.getItem("permission"))
		if (permitObj === null) {
			return true
		}

		return permitObj[keyName]
	},

	getLocalTheme() {
		const theme = localStorage.getItem('nowtheme')
		if (!theme) {
			return '0'
		}

		return theme
	},

	sitePostRequest(options) {
		const url = BASE_URL + options.url
		const method = 'POST'
		const data = options.data || {}
		return new Promise((resolve, reject) => {
			axios({
				url: url,
				method: method,
				data: data,
			})
				.then((res) => {
					localStorage.setItem('netState', 1)
					if (res.data.resultCode === successCode) {
						resolve(res.data);
					} else {
						resolve(res.data);
					}
				})
				.catch((err) => {
					localStorage.setItem('netState', 2)
					if (err) {
						const tipMsg = '网络不稳定，请重新登录'
						MessageBox.confirm(tipMsg, "提示", {
							confirmButtonText: "确定",
							cancelButtonText: null,
							type: "warning",
							showCancelButton: false,
						}).then(() => {
							// setLocalNetTip(2)
							localStorage.setItem('netState', 2)

						}).catch(() => {

						});
					}
					reject(err);
				});
		});
	},

	postRequest: (options) => {

		// 返回一个promise对象
		const site = JSON.parse(localStorage.getItem("siteObj"))
		if (site === null) {
			//清缓存之后，跳到登录界面
			localStorage.setItem('wsState', '5')
			localStorage.setItem('loginSuccess', '0')
			closeWebsocket()
			// setTimeout(() => {
			// 	console.log("跳回登录页===>3",localStorage.getItem('wsState'))
			// 	router.push('/')
			// 	localStorage.setItem("token",null)
			// }, 300)

			return
		}

		config.setSite(site)
		SERVICE_URL = site.webUrl
		const itype = options.itype
		if (itype !== undefined) {
			if (itype === '1') {
				SERVICE_URL = site.webUrl
			} else if (itype === '2') {
				SERVICE_URL = BASE_URL
			}
		}
		const url = SERVICE_URL + options.url
		const method = options.method || 'GET'
		const data = options.data || {}
		const responseType = options.responseType || ""
		let token = localStorage.getItem("token")
		config.setToken(token)
		axios.defaults.headers.common['Authorization'] = token
		return new Promise((resolve, reject) => {
			axios.default.comm
			axios({
				url: url,
				method: method,
				data: data,
				responseType: responseType
			})
				.then((res) => {
					localStorage.setItem('netState', 1)
					if (res.data.resultCode === successCode) {
						resolve(res.data)

					} else if (res.data.resultCode === noTokenCode) {
						localStorage.setItem('wsState', '4')
						localStorage.setItem('loginSuccess', '0')
						closeWebsocket()
						// setTimeout(() => {
						// 	router.push('/')
						// }, 300)

					} else {
						resolve(res.data);
					}
					store.state.errwinCount = 0

					// http请求成功 发送通信
					// if (this.$nodeFs) {
					// 	const ipc = this.$electron.ipcRenderer;
					// 	ipc.send("temp-httpSuccessLog");
					// }
				})
				.catch((err) => {
					if (err) {
						// http请求失败 发送通信
						console.log("err====", err, store.state.errwinCount)
						// if (this.$nodeFs) {
						// 	const ipc = this.$electron.ipcRenderer;
						// 	ipc.send("temp-httpErrLog");
						// }
						var count = store.state.errwinCount;
						if (count == 0) {
							console.log("err====弹窗成功");
							store.state.errwinCount++
							const tipMsg = '网络不稳定，请重新登录'
							Message.error(tipMsg)
							localStorage.setItem('netState', 2)
							// MessageBox.confirm(tipMsg, "提示", {
							// 	confirmButtonText: "确定",
							// 	cancelButtonText: null,
							// 	type: "warning",
							// 	showCancelButton: false,
							// }).then(() => {
							// 	// setLocalNetTip(2)
							// 	localStorage.setItem('netState', 2)

							// }).catch(() => {

							// });
						}
						setTimeout(() => {
							store.state.errwinCount = 0
						}, 1000)
					}
					reject(err);
				});
		});
	},

	autoStatusRequest: (options) => {
		// 返回一个promise对象
		const site = JSON.parse(localStorage.getItem("siteObj"))
		if (site === null) {
			//清缓存之后，跳到登录界面
			localStorage.setItem('wsState', '5')
			localStorage.setItem('loginSuccess', '0')
			closeWebsocket()
			// setTimeout(() => {
			// 	console.log("跳回登录页===>5",localStorage.getItem('wsState'))
			// 	router.push('/')
			// 	localStorage.setItem("token",null)
			// }, 300)

			return
		}

		SERVICE_URL = site.webUrl
		const url = SERVICE_URL + options.url
		const method = options.method || 'GET'
		const data = options.data || {}
		const responseType = options.responseType || ""
		let token = localStorage.getItem('token')
		axios.defaults.headers.common['Authorization'] = token

		return new Promise((resolve, reject) => {
			axios.default.comm
			axios({
				url: url,
				method: method,
				data: data,
				responseType: responseType
			})
				.then((res) => {
					localStorage.setItem('netState', 1)
					if (res.data.resultCode === successCode) {
						resolve(res.data)

					} else if (res.data.resultCode === noTokenCode) {
						localStorage.setItem('wsState', '4')
						localStorage.setItem('loginSuccess', '0')
						closeWebsocket()
						// setTimeout(() => {

						// 	console.log("跳回登录页===>6",localStorage.getItem('wsState'))
						// 	router.push('/')
						// 	localStorage.setItem("token",null)
						// }, 300)

					} else {
						resolve(res.data);
					}
				})
				.catch((err) => {
					if (err) {
						const tipMsg = '网络不稳定，请重新登录'
						MessageBox.confirm(tipMsg, "提示", {
							confirmButtonText: "确定",
							cancelButtonText: null,
							type: "warning",
							showCancelButton: false,
						}).then(() => {
							// setLocalNetTip(2)
							localStorage.setItem('netState', 2)

						}).catch(() => {

						});
					}
					reject(err);
				});
		});
	},

	/**
	 * excel上传
	 */
	uploadFileRequest: (options) => {
		// 上传照片
		const site = JSON.parse(localStorage.getItem("siteObj"))
		SERVICE_URL = site.webUrl
		const url = SERVICE_URL + options.url

		const method = options.method || 'GET'
		const data = options.data || {}

		let config = {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}

		let token = localStorage.getItem('token')
		axios.defaults.headers.common['Authorization'] = token

		return new Promise((resolve, reject) => {
			// 添加请求头
			axios.default.comm
			axios({
				url: url,
				method: method,
				data: data,
				config: config
			})
				.then(res => {
					if (res.data.resultCode === '10000') {
						return res.data.data
					} else {
						MessageBox.confirm(res.data.desc, "提示", {
							confirmButtonText: "确定",
							cancelButtonText: null,
							type: "warning",
							showCancelButton: false,
						})

						resolve(res.data)
					}
				}).catch(err => {
					reject(err)
				})
		});
	},


	// 数组中的数据转化成字符串，每项以空格隔开
	// arrDataToStr(arr) {
	// 	arr.join(' ');
	// }
}
